import Axios from 'axios';
import applyCaseMiddleware from 'axios-case-converter';
import FileSaver from 'file-saver';

const source = Axios.CancelToken.source();

const clearEmpty = (formValues) => {
	Object.keys(formValues).forEach((key) => {
		if (typeof formValues[key] !== 'boolean' && !formValues[key])
			delete formValues[key];
	});
	return formValues;
};

const axios = applyCaseMiddleware(
	Axios.create({
		headers: { app_id: 'Paperless',  },
		baseURL: process.env.REACT_APP_API_LOCATION,
		withCredentials: true,
		crossDomain: true,
	}),
	{ ignoreHeaders: true }
);

axios.interceptors.request.use(
	(config) => {
		console.log(
			`${config.method} request sent to ${
				config.url
			} at ${new Date().toLocaleString()}`
		);
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export const sendGetRequest = async (path) => {
	try {
		const res = await axios.get(path);
		return res;
	} catch (error) {
		return { error };
	}
};

export const cancelGetRequest = async (path) => {
	try {
		const res = await axios.get(path, { cancelToken: source.token });
		return res;
	} catch (error) {
		return { error };
	}
};

export const sendMultipleGetRequest = async (paths) => {
	try {
		const res = await Promise.all(paths.map((path) => axios.get(path)));

		return res.map((r) => r.data);
	} catch (error) {
		return { error };
	}
};

//Unneeded join in express?
/* export const sendGetRequestForRelationData = async (baseTable, relation) => {
	const paths = [];
	let ids = "";
	const foreignIds =
		baseTable && baseTable.length
			? baseTable.map((val) => val[relation.foreignKey])
			: [baseTable[relation.foreignKey]];
	foreignIds.forEach((id) => paths.push(`/${relation.table}/${id}`));
	foreignIds.forEach((id) => (ids = `${ids}id=${id}&`));
	const path = `/${relation.table}?${ids}`;

	return await sendGetRequest(path);
};

export const sendGetRequestForJoinedRelationData = async (path, relations) => {
	let ret = await sendGetRequest(path);
	const promises = relations.map(async (relation) => {
		const temp = await sendGetRequestForRelationData(ret.data, relation);
		return temp.data;
	});
	const relatedData = await Promise.all(promises);

	relatedData.forEach((data, index) => {
		ret.data = joinRelatedRowData(ret.data, relations[index], data);
	});

	return ret;
}; */

export const sendDownloadRequest = async (path) => {
	try {
		axios.get(path, {responseType: 'blob'}).then((response) => {
			//let fileName =  r.headers['content-disposition'].split('filename=')[1];
			//let blob = new Blob([r.data]);
			//FileSaver.saveAs(blob, "hello world.xlxs");
			const fileNameHeader = "x-suggested-filename";
			const suggestedFileName = response.headers[fileNameHeader];
			const effectiveFileName = (suggestedFileName === undefined
						? "file.xlsx"
						: suggestedFileName);
			console.log("Received header [" + fileNameHeader + "]: " + suggestedFileName
						+ ", effective fileName: " + effectiveFileName);

			// Let the user save the file.
			FileSaver.saveAs(response.data, effectiveFileName);

			       
		}).catch(err => {
			console.log(err);
		});
		return
	} catch (error) {
		return { error };
	}
};

export const sendPostRequest = async (path, postData) => {
	try {
		return await axios.post(path, clearEmpty(postData));
	} catch (error) {
		return { error };
	}
};

export const sendPutRequest = async (path, updateData) => {
	try {
		return await axios.put(path, clearEmpty(updateData));
	} catch (error) {
		return { error };
	}
};

export const sendDeleteRequest = async (path, deleteData) => {
	try {
		return await axios.delete(path, {
			data: { ...deleteData, inactive: true },
			//data: { ...deleteData},
		});
	} catch (error) {
		return { error };
	}
};
